import { colorMessageScope } from '../../Services/Vehicle/Vehicle.messages';

import { transformOptionsByMessageIds, MessageOptions } from './TransformOptionsByMessageId';

export type ColorMessageId = keyof typeof colorMessageScope;

const COLORS_BY_MESSAGE_ID: Record<ColorMessageId, MessageOptions> = {
  beige: {
    ids: ['beige'],
    label: 'Beige',
  },
  black: {
    ids: ['black', 'noir'],
    label: 'Black',
  },
  blue: {
    ids: ['blue', 'bleu'],
    label: 'Blue',
  },
  brown: {
    ids: ['brown', 'brun'],
    label: 'Brown',
  },
  gold: {
    ids: ['gold', 'dore'],
    label: 'Gold',
  },
  green: {
    ids: ['green', 'vert'],
    label: 'Green',
  },
  grey: {
    ids: ['grey', 'gris'],
    label: 'Grey',
  },
  orange: {
    ids: ['orange'],
    label: 'Orange',
  },
  other: {
    ids: ['other'],
    label: 'Other',
  },
  othercolor: {
    ids: ['othercolor'],
    label: 'Other Colors',
  },
  red: {
    ids: ['red', 'rouge'],
    label: 'Red',
  },
  purple: {
    ids: ['purple', 'violet'],
    label: 'Purple',
  },
  silver: {
    ids: ['silver', 'argente'],
    label: 'Silver',
  },
  white: {
    ids: ['white', 'blanc'],
    label: 'White',
  },
  yellow: {
    ids: ['yellow', 'juane'],
    label: 'Yellow',
  },
};

const COLORS = transformOptionsByMessageIds(COLORS_BY_MESSAGE_ID);

export { COLORS };
